<template>

    <div>
        <div class="row margin-bottom">
            <div class="col-sm-12">
                <h3 style="margin-top:0;">Ingeplande vakantieuren</h3>
            </div>
        </div>
        <div>
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Datum/Periode</th>
                        <th>Aantal uren</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="planned.length === 0"><td colspan="2">Er zijn geen ingeplande vakantieuren gevonden</td></tr>
                    <tr v-for="item in planned">
                        <td>
                            <span>{{ moment(item.date).format('DD-MM-YYYY') }}</span>
                        </td>
                        <td>{{ item.hours }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import moment from "moment";

export default {

    data() {
        return {
            loaded:false,
            moment:moment,
            planned:[],
        }
    },

    methods: {
        getPlannedHours() {
            axios.get(this.url)
                .then(resp => this.planned = resp.data.data)
                .catch(() => this.$snotify.error('Er is een fout opgetreden bij het ophalen van de ingeplande vakantieuren'))
                .finally(() => this.loaded = true);
        },
    },

    mounted() {
        this.getPlannedHours();
    },

    name:'HrVacationHoursPlanned',

    props: {
        url: {
            required:true,
            type:String,
        },
    },

}

</script>
